import { BuildUserAttendCampaignsDTO } from './types'

export function buildUserAttendCampaigns({ attendCampaigns, currentCompanyId }: BuildUserAttendCampaignsDTO) {
  if (!attendCampaigns?.length) return
  const currentAttendCampaigns = attendCampaigns?.filter(campaign => campaign.companyId === currentCompanyId) || []
  return currentAttendCampaigns?.map(campaign => campaign.id) || []
}
